{
  "it": {
    "tools": {
      "descriptions": {
        "verseGuide": "Guida di viaggio completa con mappe dettagliate del sistema, punti di interesse e percorsi di esplorazione nell'universo di Star Citizen",
        "starCitizenTools": "Wiki guidato dalla comunità con documentazione estesa su navi, armi, luoghi, meccaniche di gioco e lore",
        "starship42": "Visualizzatore 3D interattivo di navi con modelli dettagliati esterni e interni, posizionamento componenti e confronti di dimensioni",
        "erkul": "Calcolatore DPS avanzato e ottimizzatore di configurazione navi con statistiche dettagliate delle armi e confronti di componenti",
        "starjump": "Strumento di visualizzazione 2D della flotta per creare bellissimi layout di navi e grafici di organizzazione della flotta",
        "itemFinder": "Database completo di localizzazione oggetti e equipaggiamenti con tracciamento disponibilità in tempo reale nell'universo",
        "starHangar": "Mercato affidabile per pacchetti di navi Star Citizen con trading sicuro e tracciamento prezzi",
        "shinytracker": "Tracker di progresso personale per missioni, reputazione, achievement e obiettivi di esplorazione con statistiche dettagliate",
        "uexCorp": "Piattaforma di trading materie prime in tempo reale con tracciamento prezzi, ottimizzazione rotte commerciali e strumenti di analisi di mercato",
        "cargoGridViewer": "Visualizzatore 3D della griglia di carico che mostra le dimensioni della stiva e l'adattamento dei container per tutte le navi",
        "scmdb": "Esplora missioni, ricompense, percorsi di reputazione, risorse minerarie e altro per Star Citizen",
        "regolith": "Strumento minerario Star Citizen con scansione rocce, calcoli di raffinazione e confronti di testine di estrazione",
        "spviewer": "Ship performance analysis tool with detailed flight characteristics, speed comparisons, and maneuverability data",
        "citizenId": "Servizio di verifica dell'identità e autenticazione OAuth di Star Citizen per strumenti della comunità",
        "hauler": "Pianificatore di rotte di trasporto merci e calcolatore di profitti per i commercianti di Star Citizen"
      },
      "categories": {
        "trading": "Commercio ed Economia",
        "loadouts": "Equipaggiamento e Combattimento",
        "mining": "Estrazione Mineraria",
        "missions": "Missioni e Database",
        "fleet": "Gestione Flotta"
      },
      "discontinued": "Questo progetto è stato dismesso.",
      "discontinuedHeading": "Progetti dismessi"
    }
  }
}
